import clsx from 'clsx';
import styles from './style.module.less';
import { Image, Button, TextLink } from '@bfe/moly';
import { useFm, useParams, useScreenType, useToast } from '@web3/base-hooks';
import {
  origin,
  publicAssetsPath,
  thousandsSeparator,
  WalletType,
} from '@web3/base-utils';
import IconHot from '@/assets/svg/icon-hot.svg';
import {
  // useCurrentWallet,
  // useUserInfo,
  useConnectWalletModal,
} from '@web3fe/infra';
import Line from '@/components/Line';
import { DirectionrightIcon } from '@bfe/moly-icons';
import { useMemo, useState } from 'react';
import { PointsGetHistory } from './dialog/PointsGetHistory';
import useHomeStore from '@/store/home';
import { PointsType } from '@/types';
import { useWallet } from '@/hooks/wallet';
import { pointsTypes } from '@/config';
import { postClaimtTypePoints } from '@/services/home';
import IconOngoing from '@/assets/svg/icon-ongoing.svg';
import { TradeRule } from './dialog/TradeRule';
import { Page } from '@/config/track-config';
import { Tooltip } from '@bfe/moly';

export const SectionTrade = () => {
  const { locale } = useParams();
  const [loading, setLoading] = useState<boolean>(false);
  const [showTradeRule, setShowTradeRule] = useState<boolean>(false);
  const [showHistory, setShowHistory] = useState<boolean>(false);
  const { isMobile } = useScreenType();
  const fm = useFm();
  const connectWallet = useConnectWalletModal();

  const { toastSuccess, toastFail, toastInfo } = useToast();
  const { supportCommonTask, walletId, walletType } = useWallet();
  const {
    fetchWalletStat,
    fetchWalletTypePoints,
    fetchWalletTotalPoints,
    walletTypePoints,
  } = useHomeStore();

  const paramsBase = useMemo(
    () => ({
      walletId,
      walletType,
    }),
    [walletId, walletType]
  );
  const tradePoints = useMemo(
    () => walletTypePoints.filter((item) => item.type === PointsType.trade),
    [walletTypePoints]
  );

  const handleClick = async () => {
    if (!supportCommonTask) {
      connectWallet.show();
    } else if (tradePoints[0].status !== 1) {
      toastInfo('没有可以领取的积分');
    } else {
      setLoading(true);
      const res = await postClaimtTypePoints({
        ...paramsBase,
        type: PointsType.trade,
      });
      if (res.success) {
        toastSuccess('Claim success!');
        fetchWalletStat();
        fetchWalletTypePoints({
          ...paramsBase,
          type: walletType === WalletType.CLOUD ? PointsType.wsot : pointsTypes,
        });
        fetchWalletTotalPoints(paramsBase);
      } else {
        toastFail(res.message);
      }
      setLoading(false);
    }
  };
  const RuleComp = () => (
    <div
      className={clsx(
        'flex',
        !supportCommonTask
          ? 'flex-col'
          : 'flex-row justify-between items-center'
      )}
    >
      <h4 className="text-xl font-medium">{fm('earnPointsByDEXPRO')}</h4>
      <TextLink
        variant="tertiary"
        className="mt-2 text-sm"
        data-spm-even="Web3UserClick"
        data-spm-data={JSON.stringify({
          page_name: Page.HomePage,
          button_name: 'Web3Points_TradeDetails',
        })}
        onClick={() => setShowTradeRule(true)}
      >
        {fm('activityRules')}
      </TextLink>
    </div>
  );
  return (
    <section className={clsx(styles['section-wrap'], 'flex mt-8')}>
      <div className={clsx('bg-card flex gap-4 relative', styles['task-left'])}>
        <Image
          className={clsx(
            styles['task-icon'],
            isMobile ? 'w-12 h-12' : 'w-15 h-15'
          )}
          src={publicAssetsPath('/png/upcoming/task-dex.png')}
          alt="dexpro"
        />
        <div>
          <h3
            className={clsx(
              'flex items-center font-semibold',
              isMobile ? 'text-base' : 'text-2xl'
            )}
          >
            {fm('earnPointsByTrade')}
            <IconHot
              className={clsx('ml-1', isMobile ? 'w-5 h-5' : 'w-6 h-6')}
              viewBox="0 0 25 24"
            />
          </h3>
          <Tooltip title={fm('earnPointsByTrading')}>
            <p
              className={clsx(
                ' text-gray-t2 font-light line-clamp-2 mt-2 cursor-pointer',
                isMobile ? 'text-xs' : 'text-sm'
              )}
            >
              {fm('earnPointsByTrading')}
            </p>
          </Tooltip>

          {supportCommonTask && (
            <>
              <Line width={400} color="#25282C" className="my-4" />
              <RuleComp />
            </>
          )}
        </div>
        {supportCommonTask && (
          <span
            className={clsx(
              styles['tip'],
              styles['tip-ongoing'],
              'text-sm text-static-black font-medium'
            )}
          >
            <IconOngoing />
            {fm('ongoing')}
          </span>
        )}
      </div>
      <div
        className={clsx(
          'bg-area flex items-center justify-between gap-6 flex-1',
          styles['task-right'],
          !supportCommonTask ? 'flex-row' : 'flex-col'
        )}
      >
        {!supportCommonTask ? (
          <>
            <RuleComp />
            <Button
              variant="secondary"
              className="text-lg w-60 h-14"
              data-spm-even="Web3UserClick"
              data-spm-data={JSON.stringify({
                page_name: Page.HomePage,
                button_name: 'Web3Points_ClaimTrade',
              })}
              onClick={() => connectWallet.show()}
            >
              {fm('toTrade')}
            </Button>
          </>
        ) : (
          <>
            <div className="bg-card w-full py-4 px-6 flex gap-8 items-center justify-between">
              <div className="flex flex-col w-1/2">
                <span className="value text-2xl font-semibold">
                  {thousandsSeparator(tradePoints[0]?.point as number)}
                </span>
                <span className="label text-sm text-gray-t2 mt-1">
                  {fm('received')}
                </span>
              </div>
              <div className="flex flex-col w-1/2">
                <span
                  className="value text-2xl font-semibold flex items-center gap-1 cursor-pointer"
                  onClick={() => setShowHistory(true)}
                >
                  {thousandsSeparator(tradePoints[0]?.unClaimPoint as number)}
                  <DirectionrightIcon
                    style={{
                      width: 16,
                      height: 16,
                    }}
                  />
                </span>
                <span className="label text-sm text-gray-t2 mt-1">
                  {fm('pointsAvailable')}
                </span>
              </div>
            </div>
            <div className="flex items-center justify-between w-full gap-6">
              <Button
                variant="secondary"
                className={clsx(
                  'text-lg  h-14',
                  tradePoints[0]?.status === 1 ? 'w-1/2' : 'w-full'
                )}
                data-spm-even="Web3UserClick"
                data-spm-data={JSON.stringify({
                  page_name: Page.HomePage,
                  button_name: 'Web3Points_GoTrade',
                })}
                onClick={() => {
                  window.open(`${origin}/${locale}/web3/dex`);
                }}
              >
                {fm('toTrade')}
              </Button>
              {tradePoints[0]?.status === 1 && (
                <Button
                  variant="primary"
                  className="text-lg w-1/2 h-14"
                  loading={loading}
                  data-spm-even="Web3UserClick"
                  data-spm-data={JSON.stringify({
                    page_name: Page.HomePage,
                    button_name: 'Web3Points_ClaimTrade',
                  })}
                  onClick={handleClick}
                >
                  {fm('receive')}
                </Button>
              )}
            </div>
          </>
        )}
      </div>
      <PointsGetHistory
        visble={showHistory}
        onCancel={() => setShowHistory(false)}
      />
      <TradeRule
        visble={showTradeRule}
        onCancel={() => setShowTradeRule(false)}
      />
    </section>
  );
};
